import styled from '@emotion/styled';
import PrimaryButton from '../../common-components/component-library/buttons/PrimaryButton';
import {
  Col,
  ColProps,
  Row,
} from '../../common-components/component-library/layout/12ColGridLayout';
import Typography from '../../common-components/component-library/text/Typography';
import { useResizeWidth } from '../../utils/hooks/useResizeWidth';
import { spacing } from '../../utils/styleguide';
import PostCard, { PostCardElement } from './PostCard';

type Props = {
  items: PostCardElement[];
  header?: string;
  maxRows?: number;
  onShowMore: () => void;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const HeaderWrapper = styled.div`
  margin-bottom: ${spacing[10]}px;
`;

const getRowItems = (items: PostCardElement[], width: number, maxRows?: number) => {
  let rowIndex = 1;
  let nrOfRows = 0;
  const rowLength = 12 as const;

  return items.map((item) => {
    const itemWidth = 4;

    if (rowIndex + itemWidth > rowLength + 1) {
      rowIndex = 1;
      nrOfRows += 1;
    }
    if (maxRows && nrOfRows >= maxRows) {
      return null;
    }
    const item_placement = (rowIndex + '/ span ' + itemWidth) as ColProps['tablet'];

    rowIndex += itemWidth;

    return { ...item, ...{ placement: item_placement } };
  });
};

export default function HorizontalList({ items, header, maxRows, onShowMore }: Props) {
  const WINDOW_WIDTH = useResizeWidth();
  // get items with their placement based on the width of the items
  const rowItems = getRowItems(items, WINDOW_WIDTH, maxRows);

  // If the final item is not null, all items will be listed on the screen
  // do not show 'load more' button
  const showLoadMoreButton = maxRows && rowItems.length > 0 && !rowItems[rowItems.length - 1];

  return (
    <div>
      <Row>
        {header && (
          <HeaderWrapper>
            <Typography variant="title">{header}</Typography>
          </HeaderWrapper>
        )}
      </Row>
      <Row>
        {rowItems.map(
          (item, i) =>
            item && (
              <Col
                tablet={item.placement}
                key={'blogPost' + i}
                style={{ marginBottom: spacing[4] }}
              >
                <section>
                  <PostCard {...item} readTime={item.readTime} createdAt={item.createdAt} />
                </section>
              </Col>
            ),
        )}
      </Row>
      {showLoadMoreButton && (
        <Wrapper>
          <PrimaryButton color={'onYellow'} onClick={onShowMore} label={'Load more'} />
        </Wrapper>
      )}
    </div>
  );
}
